import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
//import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import store,{persistor} from "./store/store";
import store from "./store/store";
import { Provider } from "react-redux";
import router from "./overrides/routes";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from 'redux-persist';
//import { PersistGate } from 'redux-persist/integration/react';
// let persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
  {/* <PersistGate loading={null} persistor={persistor}> */}
    
      <BrowserRouter>

      {router}

      </BrowserRouter>
     {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
